module.exports = __webpack_public_path__ + "static/img/th-crads-invest2-04.e69996b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-invest2-04.png
// module id = VPJU
// module chunks = 1